import React from 'react'
import { Alert } from '@ztechapps/webui.util'

/** How the What's New modal picks its post — shown above the blog table while the What's New blog category is selected. */
export const WhatsNewNote = () => (
  <Alert type="info" className="m-3 p-2 small">
    <div className="fw-bold">How What's New works</div>
    <ul className="mb-0 ps-4">
      <li>
        Only a post in this category with the status Internal is shown. Draft, Active and InActive posts are ignored.
      </li>
      <li>
        The newest post, by the date it was created, is the one shown. Editing an older post never makes it the latest.
      </li>
      <li>It opens once for each user, when they load the Overview page, until a newer post is created.</li>
      <li>The What's New item in the avatar menu reopens the latest post any time.</li>
      <li>Users need the blog.canView permission to see it.</li>
    </ul>
  </Alert>
)
